import camelcase from 'camelcase';

import { COLUMN } from '@pages/Filing/ConversionTool/MappingSteps/CTStepOne/constants';

/**
 * Returns InitialValues for step 1.
 * @returns {{}}
 */
export const conversionToolInitialValuesModel = (columns = [], empty = false) =>
  columns.reduce(
    (acc, curr) =>
      empty
        ? {
            ...acc,
            [camelcase(curr?.id)]: {
              ...curr,
              value: '',
              optionalValue: '',
              disabled: false,
              selected: false,
              index: null,
            },
          }
        : {
            ...acc,
            [camelcase(curr?.id)]: {
              ...curr,
              value: curr?.value ?? COLUMN,
              optionalValue: curr?.optionalValue ?? '',
              disabled: curr?.disabled ?? false,
              selected: curr?.selected ?? false,
              index: curr?.index ?? null,
            },
          },
    {}
  );
